/* eslint-disable no-useless-escape */
import Slugify from 'slugify'
export const config = (name, definition) => {
  return [window.location.origin, 'show', Slugify(name, { lower: true }), definition].join('/')
}
export const definition = () => {
  if (location.href.match(/\/show\/[^\/]+\/([^\/]+)/gmi)) {
    return location.href.split('/').pop()
  }
}
export const configSystem = (name, definition) => {
  return [window.location.origin, 'system', Slugify(name, { lower: true }), definition].join('/')
}
export const definitionSystem = () => {
  if (location.href.match(/\/system\/[^\/]+\/([^\/]+)/gmi)) {
    return location.href.split('/').pop()
  }
}
